"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformApiTokenApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * CRUD operations for Platform API tokens.
 * Platform API tokens can be limited in scope and lifetime.
 * Use Platform API tokens for applications making use of the Platform API.
 * Limit their scope as much as possible.
 */
class SdPlatformApiTokenApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "apitokens";
    }
    /**
     * Get the token.
     * @param key_id
     * @returns api token response.
     */
    get(key_id) {
        return super.__get(SdPlatformRequestId_1.RequestId.ApiTokenGet, key_id);
    }
    /**
     * Query the API tokens.
     * @param query - {@link SdPlatformApiTokenQueryParameters} optional query parameters.
     * @returns query response with @see {@link SdPlatformResponseApiToken} as result.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.ApiTokenQuery, query);
    }
    /**
     * Create a token.
     * @param body - {@link SdPlatformRequestApiTokenCreate} body or create token parameters.
     * @returns @see {@link SdPlatformResponseApiTokenWithSecret} as result.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.ApiTokenCreate, body);
    }
    /**
     * Update and API token.
     * @param key_id
     * @param @see {@link SdPlatformRequestApiTokenPatch} patch body with parameters.
     * @returns patch response with @see {@link SdPlatformResponseApiToken}
     */
    patch(key_id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.ApiTokenPatch, key_id, body);
    }
    /**
     * Delete an API token.
     * @param  key_id
     */
    delete(key_id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.ApiTokenDelete, key_id);
    }
}
exports.SdPlatformApiTokenApi = SdPlatformApiTokenApi;
//# sourceMappingURL=SdPlatformApiTokenApi.js.map